<!-- 课程视频 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="650px" top="200px" @close="handleClose"
        :modal-append-to-body="false">
        <div class="tc-main">
            <div class="tabs">
                <div class="tabs__item" v-for="(item, index) in tabList" :key="index" @click="changeTab(item.value)" :style="{
                    'border-bottom': activeName == item.value ? '1px solid #12618A' : 'none',
                }">
                    <span>
                        {{ item.label }}
                    </span>
                </div>

            </div>
            <div class="content">
                <el-form :disabled="disabled" label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm"
                    label-width="100px" class="demo-ruleForm">
                    <div v-show="activeName == '0'">

                        <el-form-item label="选择大纲：" prop="contents_id">
                            <el-cascader v-model="ruleForm.contents_id" :options="options" style="width: 100%;" :props="{
                                checkStrictly: true,
                                label: 'contents_name',
                                value: 'contents_id',
                                children: 'children'

                            }" clearable></el-cascader>
                        </el-form-item>

                        <el-form-item label="名称" prop="name">
                            <el-input v-model="ruleForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="课程简介" prop="intro">
                            <el-input type="textarea" placeholder="请输入课程视频简要介绍..." v-model="ruleForm.intro" maxlength="200"
                                show-word-limit rows="4">
                            </el-input>
                        </el-form-item>
                        <div class="box">
                            <el-form-item label="价格：" prop="price" label-width="60px" style="width: 250px">
                                <el-input placeholder="最大10000" v-model.number="ruleForm.price">
                                    <template slot="append">
                                        <p class="color_red">元</p>

                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="AI学分：" prop="credits" label-width="80px" style="width: 230px">
                                <el-input placeholder="请输入" v-model.number="ruleForm.credits">
                                    <template slot="append">
                                        <p class="color_primary">学分</p>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <span class="color_red margin_left_5">
                                (可分配学分：{{ allocableCredits }}分)
                            </span>
                        </div>

                    </div>
                    <div class="box2" v-show="activeName == '1'">
                        <div class="cover_box">
                            <img  :src="$imgUrl(ruleForm.cover)" class="avatar">
                        </div>
                        


                        <div class="video_box" v-if="dialogVisible">

                            <video style="width: 100%;height: 240px;" :src="$imgUrl(ruleForm.file_name)" controls></video>
                        </div>


                    </div>
                </el-form>
            </div>
        </div>

        <!-- v-if  从新渲染 -->
        <span slot="footer" class="dialog-footer" v-if="!disabled">
            <el-button type="primary" @click="handleOk">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>

        </span>

        <el-dialog v-dialogDrag title="裁切课程封面" :visible.sync="cropperModel.val" width='1100px' top="200px" :modal="false"
            :append-to-body="true" v-if="cropperModel.val">
            <v-vuecropper :cropperModel="cropperModel" :imgFile="vuecropper_file" :imgW="300" :imgH="185"
                v-on:upload="uploadFn"></v-vuecropper>
        </el-dialog>
    </el-dialog>
</template>

<script>

import vuecropper from "@/components/commonComponents/vueCropper.vue";
export default {
    props: {
        videoInfo: {
            type: Object,
        }
    },
    components: {

        // previewVideo,
        "v-vuecropper": vuecropper,

    },
    data() {

        return {
            dialogVisible: false,
            // 裁剪
            cropperModel: { val: false },
            vuecropper_file: '',
            // 裁剪
            disabled: false,
            title: '课程视频信息',
            options: [],
            accept: ["video/avi", "video/mp4", "video/mov", "video/mkv"],
            tabList: [
                {
                    label: '视频简介',
                    value: '0'
                },
                {
                    label: '上传视频',
                    value: '1'
                },
            ],
            activeName: '0',
            allocableCredits: null,
            ruleForm: {
                "outline_name": "",
                id: '',//	视频课程 ID
                name: '',//	视频课程名称
                intro: '',//	课程介绍
                outline_id: '',//	主课程详情 ID
                contents_id: '',//	课程大纲目录 ID
                enterprise_id: '',//	企业 id
                enterprise_name: '',//	企业名称
                price: null,//	float64	价格
                credits: null,//	int	学分
                file_name: '',//	文件名称
                cover: '',//	封面
            },
            fileList: [],
            rules: {
                contents_id: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '请输入视频课程名称', trigger: 'blur' },

                ],
                price: [
                    { required: true, message: '请输入价格', trigger: 'blur' },

                ],
                credits: [
                    { required: true, message: '请输入AI学分', trigger: 'blur' },

                ],
                cover: [
                    { required: true, message: '请上传封面', },
                ]

            }
        }
    },
    methods: {
        init(item) {
            this.disabled = false
            this.activeName = '0'
            this.fileList = []
            this.ruleForm = {
                "outline_name": "",

                id: '',//	视频课程 ID
                name: '',//	视频课程名称
                intro: '',//	课程介绍
                outline_id: item.outline_id,//	主课程详情 ID
                contents_id: [],//	课程大纲目录 ID
                enterprise_id: item.enterprise_id,//	企业 id
                enterprise_name: item.enterprise_name,//	企业名称
                price: null,//	float64	价格
                credits: null,//	int	学分
                file_name: '',//	文件名称
                cover: '',//	封面
            }
            this.getOptions()
            this.trainingCoursegetRemainingScore(item.outline_id)
        },
        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: {
                        outline_id: this.ruleForm.outline_id
                    }
                }).then((res) => {
                    if (res.data.code == 0) {
                        if (res.data.data && res.data.data.length > 0) {
                            res.data.data.forEach(item => {
                                item.fold = true
                            })
                            this.options = res.data.data
                        } else {
                            this.options = []
                        }



                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { });
        },
        trainingCoursegetRemainingScore(outline_id) {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingCoursegetRemainingScore, {
                    data: {
                        outline_id
                    }
                }).then((res) => {
                    if (res.data.code == 0) {

                        this.allocableCredits = Number(res.data.data) >= 0 ? res.data.data : 0


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });

        },
        handleClose() {

            this.$refs['ruleForm'].clearValidate()

            // this.dialogVisible = false

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {


                    let obj = {
                        ...this.ruleForm,

                    }
                    obj.contents_id = obj.contents_id.length ? obj.contents_id[0] : ''
                    obj.file_name = this.fileList.length ? this.fileList[0].path : ''
                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.trainingCourseVideoAdd, {
                            data: obj
                        }).then((res) => {
                            if (res.data.code == 0) {
                                this.$message({ type: "success", message: '添加成功' });
                                this.$emit('ok')
                                this.dialogVisible = false


                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        }).catch((err) => {
                            // this.loading = false; 
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        changeTab(value) {
            this.activeName = value;
            switch (value) {
                case '0':
                    // this.$nextTick(() => {
                    //     this.$refs.preview1.getData(this.left_list_value)
                    // })
                    break;

                default:
                    break;
            }
            // if (value == 0) {
            //     this.path = '/data'
            //     this.cenjiclick('')
            //     this.bycodelist('DM-IMG-TPSCGS', 1)
            //     this.bycodelist('DM-VIDEO-SPSCGS', 2)
            // } else if (value == 1) {
            //     this.path = '/pic'
            //     this.fileslist()
            // } else {
            //     this.path = '/video'
            //     this.fileslist()
            // }
            // this.tableData = []
            // this.mydata.path = this.path
        },
        convertBase64ToFile(base64String, fileName) {
            const byteCharacters = atob(base64String.substring(base64String.indexOf(',') + 1));
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'image/jpg' });
            const file = new File([blob], fileName, { type: blob.type });
            return file;
        },
        // 上传前
        beforeUpload(file) {
            console.log(333);
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;
            const hasVideo = this.fileList.length
            if (!hasVideo) {
                this.$message({ type: "error", message: "请先上传视频!" });
            }
            if (!isJPG) {
                this.$message({ type: "error", message: "上传头像图片只能是 JPG 格式!" });
            }
            if (!isLt2M) {
                this.$message({ type: "error", message: "上传头像图片大小不能超过 2MB!" });

            }

            if (hasVideo && isJPG && isLt2M) {
                this.cropperModel.val = true
                this.vuecropper_file = [{
                    url: URL.createObjectURL(file),
                }];
            }
            return isJPG && isLt2M;
        },
        // 上传前
        beforeUpload1(file) {
            console.log(333);
            const isJPG = this.accept.includes(file.type)
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message({ type: "error", message: "上传的视频格式不对!" });
            }
            // if (!isLt2M) {
            //     this.$message({ type: "error", message: "上传头像图片大小不能超过 2MB!" });

            // }
            return isJPG;
        },
        // 上传
        uploadFn(file) {


            let newFile = this.convertBase64ToFile(file, this.ruleForm.outline_id);
            var formdata = new FormData()
            formdata.append('file', newFile, this.ruleForm.outline_id + '_cover.jpg');
            // formdata.append('filename',this.ruleForm.outline_id+'.jpg');
            formdata.append('rename', '0');
            //this.$baseUrl.filesupload + '/public/trainingCourse/' + localStorage.getItem('enterprise_id') + '/pic'
            //先测试使用
            this.$axios.post(this.$baseUrl.filesupload + '/' + localStorage.getItem('enterprise_id') + '/public/trainingCourse/pic', formdata,
                {
                    headers: {
                        'token': localStorage.getItem("token"),
                        'content-type': 'multipart/form-data'
                    }
                }
            ).then((res) => {
                if (res.data.code == 0) {
                    this.ruleForm.cover = res.data.data[res.data.data.length - 1].upload_path;
                    this.$forceUpdate()

                } else {
                    this.$message({ type: "error", message: res.data.msg })
                }

            })

        },
        // 上传
        uploadFn1({ file }) {



            var formdata = new FormData()
            formdata.append('file', file);
            formdata.append('rename', '1');
            //this.$baseUrl.filesupload + '/public/trainingCourse/' + localStorage.getItem('enterprise_id') + '/video'
            //先测试上传到临时位置
            this.$axios.post(this.$baseUrl.filesupload + '/' + localStorage.getItem('enterprise_id') + '/trainingCourse/video', formdata,
                {
                    headers: {
                        'token': localStorage.getItem("token"),
                        'content-type': 'multipart/form-data'
                    }
                }
            ).then((res) => {
                if (res.data.code == 0) {
                    let data = res.data.data[res.data.data.length - 1];
                    // if (data.filename.length > 50) {
                    //     data.filename = data.filename.slice(0, 20) + '...' + data.filename.slice(data.filename.indexOf('.') - 20, data.filename.length);
                    // }
                    this.fileList = [{
                        name: data.filename,
                        path: data.upload_path
                    }]
                    if (this.fileList.length > 2) {
                        this.fileList = this.fileList.slice(-3)
                    }
                    this.$forceUpdate()
                } else {
                    this.$message({ type: "error", message: res.data.msg })
                }


            })

        },
        // 查看
        init(data) {
            this.activeName = '0'
            this.disabled = true
            this.fileList = data.file_name ? [{
                path: data.file_name,
            }] : []
            this.ruleForm = data
            this.getOptions()
            this.trainingCoursegetRemainingScore(this.ruleForm.outline_id)
        },
        // 视频预览
        previewVideo(video) {
            this.$refs.previewVideo.dialogVisible = true;
            this.$refs.previewVideo.src = video;

        },
    }
}
</script>

<style lang="less" scoped>
.tc-main {
    height: 320px;
    margin: 0 auto;
}

// tab样式
.tabs {
    height: 40px;
    border-bottom: 1px solid #e4e7ed;
    box-sizing: border-box;
    background-color: #fff;

    .tabs__item {
        // width: 90px;
        height: 100%;
        line-height: 40px;
        padding: 0 20px;
        text-align: center;
        display: inline-block;
        box-sizing: border-box;
    }


    .tabs__item:hover {
        cursor: pointer;
    }


}

.box {
    display: flex;
    align-items: center;
}

.box2 {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
}

.videoList {
    display: flex;
    align-items: center;

    p {
        flex: 1;
        min-width: 0;
    }

    i {
        width: 20px;
    }
}

.courseImage {
    // height: 100%;

    .required {
        width: 25px;
        content: '*';
        color: #F56C6C;
        text-align: right;
        margin-right: 4px;
    }

    /deep/ .el-form-item__content {
        display: flex;
        margin-left: 0 !important;

        .courseImageUpload {
            height: 161px;
            // flex: 1;
            // min-width: 0;
            width: 226px;

            .el-upload.el-upload--text {
                width: 100%;
                height: calc(100% - 0px);
            }

            .avatar-uploader-icon {
                // font-size: 28px;
                color: #8c939d;
                // width: 100%;
                // height: 100%;
                line-height: 161px;
                text-align: center;
            }

            img {
                height: 100%;
                width: 100%;

                object-fit: cover;
            }
        }
    }
}
.cover_box{
    width: 226px;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.video_box {
    width: 350px;
    // /deep/ .el-form-item__content {

    //     margin-left: 0 !important;


    // }
}
</style>